import { MapFilter } from "../types";
import { getItemTypeColor, MAP_COLORS } from "../utils/colors";

type ListingItemDotProps = {
  marginLeft?: number;
  diameter?: number;
  type: MapFilter;
};

export const ListingItemDot: React.FC<ListingItemDotProps> = ({
  marginLeft,
  diameter = 14,
  type,
}) => {
  const color: string = getItemTypeColor(type);

  return (
    <div
      style={{
        width: `${diameter}px`,
        height: `${diameter}px`,
        backgroundColor: color,
        borderRadius: "50%",
        border: `1px solid ${MAP_COLORS.MARKER_BORDER}`,
        marginLeft: marginLeft || "0px",
      }}
    />
  );
};
